const WebsiteCoding: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-lg font-semibold mb-3">🌐 3 Website Latihan Coding Gratis yang Wajib Dicoba</h2>
            <p className="mb-4">
                Mau jago ngoding tapi bingung mulai dari mana? Tenang, sekarang banyak platform online yang bisa kamu akses secara gratis untuk latihan coding. Berikut 3 website favorit para coder pemula sampai pro:
            </p>

            <ul className="list-disc list-inside space-y-2 mb-4">
                <li>
                    <a href="https://www.hackerrank.com" className="text-blue-600 hover:underline" target="_blank">
                        💻 HackerRank
                    </a>
                    <p>Cocok untuk pemula karena soal dikategorikan berdasarkan topik seperti array, string, hingga algoritma. Ada juga sertifikat setelah menyelesaikan modul!</p>
                </li>
                <li>
                    <a href="https://leetcode.com" className="text-blue-600 hover:underline" target="_blank">
                        🧩 LeetCode
                    </a>
                    <p>Fokus ke persiapan wawancara kerja dan kompetisi. Banyak soal sulit tapi menantang, lengkap dengan pembahasan dan diskusi dari user seluruh dunia.</p>
                </li>
                <li>
                    <a href="https://codeforces.com" className="text-blue-600 hover:underline" target="_blank">
                        ⚔️ Codeforces
                    </a>
                    <p>Platform utama buat kamu yang ingin serius terjun ke dunia competitive programming. Ada kontes rutin mingguan dan komunitas global yang aktif banget!</p>
                </li>
            </ul>

            <p className="text-gray-700">
                Pilih platform yang sesuai dengan tujuanmu, lalu mulai latihan secara rutin. Ingat, skill coding dibentuk dari kebiasaan dan latihan terus-menerus! 💪
            </p>
        </div>
    )
}
export default WebsiteCoding